import _extends from "@babel/runtime/helpers/extends";
import PropTypes from "prop-types";
import React, { createContext } from "react";
const defaultRootContext = {
  isRtl: false
};
export const RootContext = /*#__PURE__*/createContext(defaultRootContext);

/**
 * @param {JSX.node} children The React children.
 * @param {{ isRtl: boolean }} context The root context value.
 * @returns {JSX.Element} The Root component.
 */
const Root = ({
  children,
  context = {},
  ...props
}) => {
  return /*#__PURE__*/React.createElement(RootContext.Provider, {
    value: {
      ...defaultRootContext,
      ...context
    }
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: "yst-root"
  }, props), children));
};
Root.propTypes = {
  children: PropTypes.node.isRequired,
  context: PropTypes.shape({
    isRtl: PropTypes.bool
  })
};
export default Root;